import {getLocalStorage} from './storage.js'
export function checkToken(){
    if(getLocalStorage("login_token")===null){
        return false;
    }else{
        return getLocalStorage("login_token");
    }
}

export function checkAgree (token){
    if(token===getLocalStorage("login_token")){
        return true;
    }else{
        return false;
    }
}